import { Grid } from "@mui/material";
import IndicatorForm from "./IndicatorForm";
import SpendingInfoForm from "./SpendingInfoForm";
import MainProjectForm from "./MainProjectForm";
import UploadFilesForm from "./UploadFilesForm";
import ResponsiblePersonForm from "./ResponsiblePersonForm";
import { InputValueProjectForm, UploadedFile } from "./domain";
import InputTextField from "../../../../components/input/inputTextField";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface EdpexProjectFormProps {
  inputValue: InputValueProjectForm;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueProjectForm>>;
  uploadedFiles: UploadedFile[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  disable?: boolean
}

const IndexProjectForm: React.FC<EdpexProjectFormProps> = ({
  inputValue,
  setInputValue,
  uploadedFiles,
  setUploadedFiles,
  disable = false
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_project_type = queryParams.get("project-type");

  const handleInputChange = (key: keyof InputValueProjectForm, value: any) => {
    setInputValue((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <section className="w-full mt-10">
      <Grid container spacing={2}>
        <MainProjectForm
          inputValue={inputValue}
          setInputValue={setInputValue}
          disabled={prop_project_type !== "add-project" || disable}
        />

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <IndicatorForm
            inputValue={inputValue}
            setInputValue={setInputValue}
            disabled={prop_project_type !== "add-project" || disable}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <SpendingInfoForm
            inputValue={inputValue}
            setInputValue={setInputValue}
            disabled={prop_project_type !== "add-project" || disable}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <ResponsiblePersonForm
            inputValue={inputValue}
            setInputValue={setInputValue}
            disabled={prop_project_type !== "add-project" || disable}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <UploadFilesForm
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            disabled={prop_project_type !== "add-project" || disable}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t("หมายเหตุ")}
            placeholder={t("หมายเหตุ")}
            value={undefined}
            onchange={(e: any) => {
              handleInputChange("description", e.target.value);
            }}
            helperText={""}
            disabled={prop_project_type !== "add-project" || disable}
            row={3}
            maxRows={5}
            disablePaddingMultiline
            multiline
            inputHeight={"auto"}
          />
        </Grid>
      </Grid>
    </section>
  );
};

export default IndexProjectForm;
